import { Icon12ClockOutline, Icon12ErrorCircle, Icon16CheckDoubleOutline, Icon16CheckOutline } from '@vkontakte/icons';
import { classNames } from '@vkontakte/vkjs';
import { Tappable } from '@vkontakte/vkui';
import { HTMLAttributes } from 'react';
import styles from './MessageBubbleIndicator.module.css';

const typeIconMap = {
  sending: Icon12ClockOutline,
  sent: Icon16CheckOutline,
  read: Icon16CheckDoubleOutline,
  error: Icon12ErrorCircle,
};

export type MessageBubbleIndicatorType = keyof typeof typeIconMap;

interface MessageBubbleIndicatorProps extends HTMLAttributes<HTMLDivElement> {
  type: MessageBubbleIndicatorType;
  testId?: string;
}

/**
 * Индикатор сообщения
 */
export function MessageBubbleIndicator(props: MessageBubbleIndicatorProps) {
  const { type, onClick, className, testId, ...rest } = props;

  const Wrap = onClick
    ? { Component: Tappable, props: { hoverMode: 'opacity', activeMode: 'opacity' } }
    : { Component: 'div' };

  const Icon = typeIconMap[type];

  return (
    <Wrap.Component
      className={classNames(styles.root, styles[`root__type_${type}`], className)}
      data-testid={testId}
      onClick={onClick}
      // Передавать key важно. Иначе есть артефакты на iOS при смене одного индикатора на другой
      key={type}
      {...Wrap.props}
      {...rest}
    >
      <Icon className={styles.icon} />
    </Wrap.Component>
  );
}
